import { Box, Tab, Tabs } from "@mui/material";

export default function LienzoTabs({ value, onChange, showClosureTabs }) {
  if (!showClosureTabs) return null;

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={value}
        onChange={(_, nextValue) => onChange(nextValue)}
        sx={{
          minHeight: 42,
          "& .MuiTab-root": {
            minHeight: 42,
            textTransform: "none",
            fontSize: 13,
            fontWeight: 800,
          },
        }}
      >
        <Tab label="Cierres" value="closures" />
        <Tab label="Resumen" value="summary" />
        <Tab label="Movimientos del Cierre" value="movements" />
        <Tab label="Caja del Cierre" value="cash" />
      </Tabs>
    </Box>
  );
}
